function getWidth() {
    return Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    );
  }
  
  
  var elms = document.getElementsByClassName( 'splide' );
  
  for ( var i = 0; i < elms.length; i++ ) {
      new Splide( elms[ i ], {
          padding     : { right: '30%' },
          type        : 'loop',
          mediaQuery  : 'min',
          breakpoints : {
              993: {
                  destroy: true,
              }
      }
      }).mount();
  }
  
  // new Splide( '.splide', {
  //     padding     : { right: '30%' },
  //     type        : 'loop',
  //     mediaQuery  : 'min',
  //     breakpoints : {
  //         993: {
  //             destroy: true,
  //         }
  //   }
  // } ).mount();
  
  /*-------------------------categories slider-----------------------------*/
  var button = document.getElementById('categoriesSlideForward');
  
  var categoriesImg = document.getElementById('categories-1');
  var categoriesImgWidth = categoriesImg.clientWidth;
  var categoriesDistance = categoriesImgWidth;
  
  
  button.onclick = function () {
      var slider = document.getElementById('categories-slider');
      sideScroll(slider,'right',30, categoriesDistance,60);
  };
  
  var back = document.getElementById('categoriesSlideBack');
  back.onclick = function () {
      var slider = document.getElementById('categories-slider');
      sideScroll(slider,'left',30, categoriesDistance,60);
  };
  
  function sideScroll(element,direction,speed,distance,step){
  
      scrollAmount = 0;
      var slideTimer = setInterval(function(){
          if(direction == 'left'){
              element.scrollLeft -= step;
          } else {
              element.scrollLeft += step;
          }
          scrollAmount += step;
          if(scrollAmount >= distance){
              window.clearInterval(slideTimer);
          }
      }, speed);
  }
  